export const CARDS_TO_SHOW = 10;
export const TRANSFORM_STYLES = {
    0: { rotation: 0 },
    1: { rotation: -25 },
    2: { rotation: 15 },
    3: { rotation: 45 },
    4: { rotation: -45 },
    5: { rotation: 15 },
} as const;
